import React from "react";

import { X } from "react-feather";

import "./style.css";

const ReplyMessage = props => {
  const { message, closeFn } = props;

  return (
    <div className="reply">
      <div className="reply__wrapper">
        <button className="reply__bttn" onClick={closeFn}>
          <X size={20} />
        </button>

        <p className="reply__author">{message.author}:</p>
        <p className="reply__body">{message.body}</p>
      </div>
    </div>
  );
}

export default ReplyMessage;